import { HelperText } from '~/components/helper-text'

import {
  DisplayNames,
  type ScopedProps,
  useInputMultiSelectContext,
} from '../../input-multi-select.context'

type InputMultiSelectHelperTextProps = React.ComponentPropsWithoutRef<
  typeof HelperText
> & {}

export const HELPER_TEXT_HEIGHT = 20

export const InputMultiSelectHelperText: React.FC<
  InputMultiSelectHelperTextProps
> = externalProps => {
  const { __scopeInputMultiSelect, iconName, withIcon, ...props } =
    externalProps as ScopedProps<InputMultiSelectHelperTextProps>

  const { isDisabled, isReadOnly, isError } = useInputMultiSelectContext(
    DisplayNames.HELPER_TEXT,
    __scopeInputMultiSelect
  )

  return (
    <HelperText
      {...props}
      disabled={isDisabled}
      readonly={isReadOnly}
      iconName={(isError && 'rdicon-warning-circle') || iconName}
      withIcon={isError || withIcon}
      hasError={isError}
      iconSize="tiny"
    />
  )
}

InputMultiSelectHelperText.displayName = DisplayNames.HELPER_TEXT
